import type { ApiError } from '@platform/api';
import type { SentryScopeTags } from '../sentry-scope';
import { enrichRequestScope } from './enrich-request-scope';

/** Tags a Sentry scope with the debugging context every ApiError capture should carry:
 *  correlation ID (if the response sent one), status code, route, and request/response context. */
export function enrichApiErrorScope(error: ApiError, scope: SentryScopeTags): void {
  const correlationId = error.headers.get('X-Correlation-Id');
  if (correlationId) {
    scope.setTag('correlation_id', correlationId);
  }
  scope.setTag('status_code', error.status);
  scope.setContext('response', { status_code: error.status });
  enrichRequestScope(error, scope);
}
